import { render, staticRenderFns } from "./DetailPermohonanNonberusaha.vue?vue&type=template&id=2769ff01&"
import script from "./DetailPermohonanNonberusaha.vue?vue&type=script&lang=js&"
export * from "./DetailPermohonanNonberusaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports